import { defineStore } from 'pinia'
import { post, get } from '@/utils/api'

export const useAuthStore = defineStore('auth', {
  state: () => ({
    loading: false,
    error: null,
    user: null, // Store user data
    token: '', // Store token
    AccessToken: '', // Store token
    RefreshTokenExpiresIn: null, // Store token
    IdToken: '', // Store token
    RefreshToken: '', // Store token
  }),
  actions: {
    async forgotPassword(email) {
      this.loading = true
      this.error = null
      try {
        const response = await post('/auth/forgot-password', { email })
        return response
      } catch (err) {
        this.error = err.response?.data?.message || 'An error occurred'
      } finally {
        this.loading = false
      }
    },

    async resetPassword(email, code, newPassword) {
      this.loading = true
      this.error = null
      try {
        const response = await post('/auth/reset-password', {
          email,
          code,
          newPassword,
        })
        return response
      } catch (err) {
        this.error = err.response?.data?.message || 'An error occurred'
      } finally {
        this.loading = false
      }
    },
    async login(username, password) {
      this.loading = true
      this.error = null
      this.mainResponse = null
      try {
        const response = await post('/auth/login', {
          email: username,
          password,
        })
        this.mainResponse = response
        if (response?.data?.code == 200) {
          this.Session = response?.data?.data?.Session
          this.email = username
          localStorage.setItem('session', response?.data?.data?.Session)
          localStorage.setItem('email', username)
        } else {
          this.error = 'Invalid credentials'
        }
      } catch (err) {
        this.error = err.response?.data?.message || 'An error occurred during login'
      } finally {
        this.loading = false
      }
      return this.mainResponse
    },
    async verifyOTP(email, otp, session) {
      this.loading = true
      this.error = null
      try {
        const response = await post('/auth/verify-mfa', {
          email,
          OtpCode: otp,
          session,
        })
        if (response?.data?.code === 200) {
          this.user = response.data.userDetails
          this.AccessToken = response.data.data.AccessToken
          this.IdToken = response.data.data.IdToken
          this.RefreshToken = response.data.data.RefreshToken

          // localStorage.setItem('AccessToken', this.AccessToken)
          // localStorage.setItem('IdToken', this.IdToken)
          // localStorage.setItem('RefreshToken', this.RefreshToken)

          return response
        } else {
          this.error = 'OTP verification failed'
        }
      } catch (err) {
        this.error = err.response?.data?.message || 'An error occurred'
      } finally {
        this.loading = false
      }
    },
    logout() {
      this.user = null
      this.token = null
      localStorage.removeItem('AccessToken')
      localStorage.removeItem('ExpiresIn')
      localStorage.removeItem('IdToken')
      localStorage.removeItem('RefreshToken')
    },
    async register(email, password) {
      this.loading = true
      this.error = null
      try {
        const response = await post('/auth/register', {
          email,
          password,
        })
        if (response?.data?.code == 200) {
          this.user = response.data.userDetails
          // You might need to handle other state updates based on your backend response
        } else {
          this.error = 'Registration failed'
        }
      } catch (err) {
        this.error = err.response?.data?.message || 'An error occurred during registration'
      } finally {
        this.loading = false
      }
    },
    async getUserRole(userId) {
      this.loading = true
      this.error = null
      try {
        // Get AccessToken from localStorage if it's not in state
        const accessToken = this.AccessToken || localStorage.getItem('AccessToken')

        if (!accessToken) {
          throw new Error('No access token found')
        }
        const response = await get(`/v1/user-roles/${userId}`, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        })

        if (response?.data?.code === 200) {
          // Optionally update Pinia state or just return
          return response
        } else {
          this.error = response?.data?.message || 'Failed to fetch user roles'
          return null
        }
      } catch (err) {
        this.error = err.response?.data?.message || 'An error occurred while fetching roles'
        return null
      } finally {
        this.loading = false
      }
    },
  },
  persist: {
    enabled: true, // Enables persistence for the entire store
    strategies: [
      {
        key: 'auth', // The key under which the state will be stored
        storage: localStorage, // Use localStorage
      },
    ],
  },
})
